module.exports = __webpack_public_path__ + "static/media/profile-icon.3acddd96.png";